interface Props {
  className?: string;
}

export default function SofaIcon({ className }: Props) {
  return (
    <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
      <path d="M27.938 11.375c2.313.313 4.063 2.25 4.063 4.625v6.688c0 1.438-1.188 2.625-2.688 2.625v1.375h-2.625v-1.375H5.313v1.375H2.688v-1.375c-1.5 0-2.688-1.188-2.688-2.625V16c0-2.375 1.75-4.313 4.063-4.625C4.376 8 7.188 5.312 10.688 5.312h10.625c3.5 0 6.313 2.688 6.625 6.063zm1.375 11.313V16c0-1.125-.875-2-2-2-1.063 0-2 .875-2 2v1.313c0 .75-.563 1.375-1.313 1.375H8c-.75 0-1.313-.625-1.313-1.375V16c0-1.125-.938-2-2-2-1.125 0-2 .875-2 2v6.688zm-4-10.875C25.188 9.688 23.5 8 21.313 8h-4v8h5.375a4.598 4.598 0 0 1 2.625-4.188zM10.688 8c-2.188 0-3.875 1.688-4 3.813a4.596 4.596 0 0 1 2.625 4.188h5.375v-8z" />
    </svg>
  )
}
